export const STATUS_BAR_HANDLE = "STATUS_BAR_HANDLE";
